// "Show the working" for a reliability figure.
//
// Every step comes from the server's `calculation` block, which is built from the same
// variables the summary is built from — never recomputed here. If the explanation and
// the number could be produced separately they would eventually disagree, and a wrong
// explanation of a right number is worse than no explanation at all.
export function CalculationTrail({ steps, open, onToggle, testId = "calc-trail" }) {
  if (!steps || !steps.length) return null;
  return (
    <div data-testid={testId}>
      <button
        onClick={onToggle}
        className="text-xs font-semibold text-blue-600 hover:text-blue-800 hover:underline"
        data-testid={`${testId}-toggle`}
      >
        {open ? "Hide details ▲" : "More details ▼"}
      </button>
      {open && (
        <div className="mt-2 space-y-2" data-testid={`${testId}-body`}>
          {steps.map((s, i) => (
            <div key={s.key || i} className="rounded-lg border border-slate-200 bg-slate-50 p-3" data-testid={`${testId}-step-${s.key || i}`}>
              <div className="flex items-baseline justify-between gap-3">
                <span className="text-xs font-bold text-slate-800">{i + 1}. {s.title}</span>
                <span className="shrink-0 text-sm font-bold text-blue-700" data-testid={`${testId}-result-${s.key || i}`}>
                  {s.result === null || s.result === undefined ? "—" : s.result}
                  {s.result !== null && s.result !== undefined && s.unit ? ` ${s.unit}` : ""}
                </span>
              </div>
              <div className="mt-1 font-mono text-[11px] text-slate-600">{s.formula}</div>
              <div className="mt-0.5 font-mono text-[11px] text-slate-800">
                = {s.substituted}
                {s.result !== null && s.result !== undefined && <> = <strong>{s.result}</strong></>}
              </div>
              {!!(s.notes || []).length && (
                <ul className="mt-1.5 space-y-0.5">
                  {s.notes.map((n, j) => (
                    <li key={j} className="text-[11px] text-slate-500">&bull; {n}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
